import React, { useState } from 'react';
import { connect } from 'react-redux';
import { last, get } from 'lodash';
// @ts-ignore
import Modal from 'components/Modal';
// @ts-ignore
import UploadFileModalContent from 'components/FileSystem/components/Files/components/UploadFileModalContent';

// @ts-ignore
import * as selectors from 'store/services/flow/selectors';
// @ts-ignore
import * as actions from 'store/services/flow/actions';

import Conflicts from './components/Conflicts';

type Files = File[];

type Props = {
  closeModal: () => void;
  isUploading: Boolean;
  resetUploadFiles: () => void;
  uploadFiles: (
    files: Files,
    path?: string,
    shouldOverwriteFiles?: boolean,
  ) => void;
  path: string[];
};

enum ModalViews {
  UPLOADFILES = 'UPLOADFILES',
  CONFLICT = 'CONFLICT',
}

type Error = { response: { status: number } };
const hasConflictsError = (error: Error) =>
  get(error, 'response.status', 400) === 409;

export const UploadFilesModal = ({
  closeModal,
  isUploading,
  resetUploadFiles,
  uploadFiles,
  path,
}: Props) => {
  const [view, setView] = useState<ModalViews>(ModalViews.UPLOADFILES);
  const [filesWithConflicts, setFilesWithConflicts] = useState<Files>([]);

  const handleUploadFilesWithConflicts = async (path?: string) => {
    setView(ModalViews.UPLOADFILES);
    await uploadFiles(filesWithConflicts, path, true);
    closeModal();
  };

  const handleUploadFiles = async (files: Files, path?: string) => {
    try {
      await uploadFiles(files, path);
      closeModal();
    } catch (err) {
      if (hasConflictsError(err)) {
        setFilesWithConflicts(files);
        setView(ModalViews.CONFLICT);
      }
    }
  };

  return (
    <React.Fragment>
      <Modal closeOnEsc isOpen maxWidth={580}>
        {view === ModalViews.CONFLICT && (
          <Conflicts
            onBack={() => {
              setView(ModalViews.UPLOADFILES);
            }}
            onCancel={closeModal}
            onUpload={() => handleUploadFilesWithConflicts(last(path))}
          />
        )}

        {view === ModalViews.UPLOADFILES && (
          <UploadFileModalContent
            isFlow
            files={filesWithConflicts}
            // initialValues is needed for the scenario that user clicks back button on
            // conflicts view. In that case UploadFileModalContent should have old value
            // in its file input.
            initialValues={
              filesWithConflicts.length > 0
                ? { file: last(filesWithConflicts) }
                : {}
            }
            isUploading={isUploading}
            resetUploadFiles={resetUploadFiles}
            uploadFiles={(files: Files) => handleUploadFiles(files, last(path))}
            onCloseRequest={closeModal}
          />
        )}
      </Modal>
    </React.Fragment>
  );
};

// @ts-ignore
const mapStateToProps = state => ({
  // isUploading is used from UploadFilesModal in order to display a spinner on Upload button
  // uploadFiles action uploads the files and after it gets the files, so we need the OR
  // bellow in order for the spinner in that button to have correct state
  isUploading: selectors.getIsUploading(state) || selectors.getIsLoading(state),
});

const mapDispatchToProps = {
  resetUploadFiles: actions.resetUploadFiles,
  uploadFiles: actions.uploadFiles,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(UploadFilesModal);
